import TriggerTemplateAction from './TriggerTemplateAction';

export default TriggerTemplateAction;
